var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8195 6.51162C19.0967 6.9003 19.2353 7.09469 19.2353 7.38235C19.2353 7.67001 19.0967 7.8644 18.8195 8.25309C17.574 9.99966 14.3931 13.7647 10.1176 13.7647C5.84218 13.7647 2.66133 9.99966 1.4158 8.25309C1.1386 7.8644 1 7.67001 1 7.38235C1 7.09469 1.1386 6.9003 1.4158 6.51162C2.66133 4.76508 5.84218 1 10.1176 1C14.3931 1 17.574 4.76508 18.8195 6.51162Z",
    stroke: "#667085",
    strokeWidth: 1.82353
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8534 7.38178C12.8534 5.87108 11.6288 4.64648 10.1181 4.64648C8.6074 4.64648 7.38281 5.87108 7.38281 7.38178C7.38281 8.89248 8.6074 10.1171 10.1181 10.1171C11.6288 10.1171 12.8534 8.89248 12.8534 7.38178Z",
    stroke: "#667085",
    strokeWidth: 1.82353
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassword);
export default __webpack_public_path__ + "static/media/view-password.d157682b95d49bdbd068c1e7e110907b.svg";
export { ForwardRef as ReactComponent };